const { default: visibleTypes } = require("./visibleTypes");

const grades = {
    "1": {
        fontsize: {
            [visibleTypes.PARAGRAPH]: 50,
            [visibleTypes.WORD_GROUP]: 70,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 110,
        cardWidth: 230,
    },
    "2": {
        fontsize: {
            [visibleTypes.PARAGRAPH]: 50,
            [visibleTypes.WORD_GROUP]: 70,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 110,
        cardWidth: 230,

    },
    "3": {
        fontsize: {
            [visibleTypes.PARAGRAPH]: 50,
            [visibleTypes.WORD_GROUP]: 70,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 110,
        cardWidth: 230,

    },
    "4": {
        fontsize: {
            [visibleTypes.PARAGRAPH]: 50,
            [visibleTypes.WORD_GROUP]: 70,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 110,
        cardWidth: 230,

    },
    "5": {
        fontsize: {
            [visibleTypes.PARAGRAPH]: 50,
            [visibleTypes.WORD_GROUP]: 60,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 110,
        cardWidth: 230,

    },
    "6": {
        fontsize: {
            [visibleTypes.PARAGRAPH]: 40,
            [visibleTypes.WORD_GROUP]: 50,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 82,
        cardWidth: 220
    },
    "7": {
        fontsize: {
            [visibleTypes.PARAGRAPH]: 40,
            [visibleTypes.WORD_GROUP]: 40,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 82,
        cardWidth: 220

    },
    "8": {
        fontsize: {
            [visibleTypes.PARAGRAPH]: 40,
            [visibleTypes.WORD_GROUP]: 40,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 82,
        cardWidth: 220

    },
    "9": {
        fontsize: {
            [visibleTypes.PARAGRAPH]: 30,
            [visibleTypes.WORD_GROUP]: 30,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 72,
        cardWidth: 220

    },
    "10": {
        fontsize: {
            [visibleTypes.PARAGRAPH]: 30,
            [visibleTypes.WORD_GROUP]: 30,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 72,
        cardWidth: 220

    },
    "11": {
        fontsize: {
            [visibleTypes.PARAGRAPH]: 30,
            [visibleTypes.WORD_GROUP]: 30,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 72,
        cardWidth: 220

    },
    "12": {
        fontsize: {
            [visibleTypes.PARAGRAPH]: 30,
            [visibleTypes.WORD_GROUP]: 30,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 72,
        cardWidth: 220

    },
    "13": {
        fontsize: {
            [visibleTypes.PARAGRAPH]: 30,
            [visibleTypes.WORD_GROUP]: 30,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 72,
        cardWidth: 220

    },
    "14": {
        fontsize: {
            [visibleTypes.PARAGRAPH]: 30,
            [visibleTypes.WORD_GROUP]: 30,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 72,
        cardWidth: 220

    },
    "15": {
        fontsize: {
            [visibleTypes.PARAGRAPH]: 30,
            [visibleTypes.WORD_GROUP]: 30,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 72,
        cardWidth: 220
    }
}

export default grades